import { portNumbers } from 'get-port'

export const config = {
  projects: {
    dashboard: process.env.DASHBOARD_URL ?? 'https://dashboard.scalar.com',
    sandbox: process.env.SANDBOX_URL ?? 'https://sandbox.scalar.com',
    registry: process.env.REGISTRY_URL ?? 'https://registry.scalar.com',
  },
  services: {
    api: process.env.BASE_URL ?? 'https://services.scalar.com',
  },
  auth: {
    callback: {
      preferredPortRange: process.env.PREFERRED_PORT
        ? Number.parseInt(process.env.PREFERRED_PORT)
        : portNumbers(4799, 5100),
    },
  },
  cdnUrl: process.env.CDN_URL ?? 'https://cdn.scalar.com',
  ssgDocsIsolateVersion: process.env.SSG_DOCS_ISOLATE_VERSION ?? '1.2.6',
} as const
